"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _overview = require("@insided/control/modules/MultiLanguage/Translation/overview");

var _common = require("@insided/shared/utils/common");

var _Language = _interopRequireDefault(require("@insided/shared/icons/Language"));

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _utils = _interopRequireDefault(require("@insided/shared/modules/MultiLanguage/utils"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function getLanguageCodeDisplayName(languageCode, languages) {
  var _languages$find;

  var locale = languages === null || languages === void 0 ? void 0 : (_languages$find = languages.find(function (language) {
    return language.code === languageCode;
  })) === null || _languages$find === void 0 ? void 0 : _languages$find.locale;
  if (!locale) return languageCode;
  return locale.replace('_', '-').toUpperCase();
}

function getShowAdminLanguageDropdown(userRoles, allowedUserRoles) {
  return _common.common.isModuleActive('contentInPreferredLanguage') && userRoles.some(function (role) {
    return allowedUserRoles.includes(role);
  });
}

var LanguageSwitcher = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LanguageSwitcher, _Component);

  var _super = _createSuper(LanguageSwitcher);

  function LanguageSwitcher() {
    var _this;

    (0, _classCallCheck2.default)(this, LanguageSwitcher);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropdownTimeout", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isDropdownOpen: false,
      selectedLanguage: {
        title: getLanguageCodeDisplayName(_this.props.selectedLanguageCode, _this.props.languages),
        value: _this.props.selectedLanguageCode
      },
      showAdminLanguageDropdown: getShowAdminLanguageDropdown(_this.props.userRoles, _this.props.allowedUserRoles)
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mapLanguagesToDropdownItems", function (languages, languageTitles) {
      var selectedLanguageCode = _this.props.selectedLanguageCode;
      return languages.filter(function (language) {
        return selectedLanguageCode && language.code !== selectedLanguageCode;
      }).map(function (language) {
        var _languageTitles$langu;

        return {
          title: (_languageTitles$langu = languageTitles[language.locale]) !== null && _languageTitles$langu !== void 0 ? _languageTitles$langu : language.name,
          onClick: function onClick() {
            return _this.onLanguageSelected(language);
          },
          value: language.locale
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAdminLanguageDropdown", function () {
      var _this$state = _this.state,
          selectedLanguage = _this$state.selectedLanguage,
          _this$state$enabledLa = _this$state.enabledLanguagesDropdownItems,
          enabledLanguagesDropdownItems = _this$state$enabledLa === void 0 ? [] : _this$state$enabledLa,
          _this$state$published = _this$state.publishedLanguagesDropdownItems,
          publishedLanguagesDropdownItems = _this$state$published === void 0 ? [] : _this$state$published;
      var groupedLanguages = [{
        groupName: 'Published languages',
        items: publishedLanguagesDropdownItems
      }, {
        groupName: 'Unpublished languages',
        items: enabledLanguagesDropdownItems
      }];
      return (0, _preact.h)(_overview.LanguagesDropdown, {
        languages: groupedLanguages,
        selectedLanguage: selectedLanguage,
        hasArrowIcon: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getEndUserLanguageDropdown", function () {
      var _selectedLanguage$val, _languageOptions;

      var _this$props = _this.props,
          languages = _this$props.languages,
          selectedLanguageCode = _this$props.selectedLanguageCode;
      var _this$state2 = _this.state,
          isDropdownOpen = _this$state2.isDropdownOpen,
          selectedLanguage = _this$state2.selectedLanguage;
      var languageOptions = [];

      if (languages !== null && languages !== void 0 && languages.length) {
        languageOptions = languages.filter(function (_ref) {
          var code = _ref.code;
          return code.toLowerCase() !== (selectedLanguageCode === null || selectedLanguageCode === void 0 ? void 0 : selectedLanguageCode.toLowerCase());
        }).sort(function (a, b) {
          return a.name < b.name ? -1 : 1;
        });
      }

      return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "main-navigation--language-switcher_selected",
        tabIndex: 0,
        role: "button",
        onClick: function onClick() {
          return _this.toggleDropdown();
        },
        onKeyDown: function onKeyDown(event) {
          if (event.key === 'Enter') {
            _this.toggleDropdown();
          }
        }
      }, _common.common.isModuleActive('showLanguageFlags') ? (0, _preact.h)("div", {
        className: (0, _classnames.default)('main-navigation--language-switcher_language-icon', "main-navigation--language-switcher_language-icon--".concat((_selectedLanguage$val = selectedLanguage.value) === null || _selectedLanguage$val === void 0 ? void 0 : _selectedLanguage$val.toLowerCase()))
      }) : (0, _preact.h)(_Language.default, {
        height: 16,
        width: 16
      }), (0, _preact.h)("span", null, selectedLanguage.title)), isDropdownOpen && (0, _preact.h)("div", {
        className: "main-navigation--language-switcher_dropdown"
      }, (_languageOptions = languageOptions) === null || _languageOptions === void 0 ? void 0 : _languageOptions.map(function (language) {
        return (0, _preact.h)("div", {
          className: "main-navigation--language-switcher_dropdown_item",
          onClick: function onClick() {
            return _this.onLanguageSelected(language);
          },
          onKeyDown: function onKeyDown() {
            return _this.onLanguageSelected(language);
          },
          key: "language-".concat(language.code),
          role: "button",
          tabIndex: 0
        }, _common.common.isModuleActive('showLanguageFlags') && (0, _preact.h)("a", {
          className: (0, _classnames.default)('main-navigation--language-switcher_language-icon', "main-navigation--language-switcher_language-icon--".concat(language.code.toLowerCase())),
          value: language.code.toLowerCase()
        }), (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
          p: "multi_language.language_title.".concat(language.locale.toLowerCase()),
          renderAsText: true
        })));
      })));
    });
    return _this;
  }

  (0, _createClass2.default)(LanguageSwitcher, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this$props2, enabledLanguages, publishedLanguages, userRoles, allowedUserRoles;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props2 = this.props, enabledLanguages = _this$props2.enabledLanguages, publishedLanguages = _this$props2.publishedLanguages, userRoles = _this$props2.userRoles, allowedUserRoles = _this$props2.allowedUserRoles;

                if (!getShowAdminLanguageDropdown(userRoles, allowedUserRoles)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this.updateLanguageTitles(enabledLanguages !== null && enabledLanguages !== void 0 ? enabledLanguages : [], publishedLanguages !== null && publishedLanguages !== void 0 ? publishedLanguages : []);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "updateLanguageTitles",
    value: function () {
      var _updateLanguageTitles = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(enabledLanguages, publishedLanguages) {
        var languages, languageTitles;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                languages = [].concat((0, _toConsumableArray2.default)(enabledLanguages), (0, _toConsumableArray2.default)(publishedLanguages));
                _context2.next = 3;
                return (0, _utils.default)(languages);

              case 3:
                languageTitles = _context2.sent;
                this.setState({
                  enabledLanguagesDropdownItems: this.mapLanguagesToDropdownItems(enabledLanguages, languageTitles),
                  publishedLanguagesDropdownItems: this.mapLanguagesToDropdownItems(publishedLanguages, languageTitles)
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateLanguageTitles(_x, _x2) {
        return _updateLanguageTitles.apply(this, arguments);
      }

      return updateLanguageTitles;
    }()
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter() {
      if (this.dropdownTimeout) clearTimeout(this.dropdownTimeout);
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      var _this2 = this;

      this.dropdownTimeout = setTimeout(function () {
        return _this2.setState({
          isDropdownOpen: false
        });
      }, 300);
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      var isDropdownOpen = this.state.isDropdownOpen;
      if (this.dropdownTimeout) clearTimeout(this.dropdownTimeout);
      this.setState({
        isDropdownOpen: !isDropdownOpen
      });
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      this.setState({
        isDropdownOpen: false
      });
    }
  }, {
    key: "onLanguageSelected",
    value: function onLanguageSelected(language) {
      var _this3 = this;

      var _this$props3 = this.props,
          onLanguageChanged = _this$props3.onLanguageChanged,
          languages = _this$props3.languages;
      this.setState({
        selectedLanguage: {
          title: getLanguageCodeDisplayName(language.code, languages),
          value: language.code
        }
      }, function () {
        _this3.closeDropdown();

        onLanguageChanged === null || onLanguageChanged === void 0 ? void 0 : onLanguageChanged(language.code);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var languages = this.props.languages;
      var showAdminLanguageDropdown = this.state.showAdminLanguageDropdown;
      return (0, _preact.h)("li", {
        className: "main-navigation--language-switcher",
        onMouseEnter: function onMouseEnter() {
          return _this4.onMouseEnter();
        },
        onMouseLeave: function onMouseLeave() {
          return _this4.onMouseLeave();
        }
      }, showAdminLanguageDropdown ? this.getAdminLanguageDropdown() : languages && languages.length > 1 && this.getEndUserLanguageDropdown());
    }
  }]);
  return LanguageSwitcher;
}(_preact.Component);

exports.default = LanguageSwitcher;